import {
    deepClone,
    getAssetExchangeNameFromMktSegId, getInstrumentName, getMktSegIdFromApiExchangeName, getMktSegIdFromMappedMktSegId, getViewAllowed, getViewAllowedOptnChain,
    modifySymbol, sortDateInStringsInSequence
} from "../../utils/global_functions";
import { OPTION_CHAIN } from "../actionTypes";
import { OPTION_CHAIN_GRID_INDEX, SCRIP_INSTRUMENTS, OPTION_CHAIN as location } from "../../utils/global_variables";
import { _fetchOptionDataBasedOnScreens } from "../../controllers";
import { store } from "../store";
import { getDistinctExpirybyTokenApi, getScripFromInstrumentAndExchangeApi } from "../../apis/nontransactional";
import { sendBestFiveRequest } from "../../apis/web_socket";


export const updateIsSIdeOptionChainSticked = (payload) => {
    return { type: OPTION_CHAIN?.IS_SIDE_OPTION_CHAIN_STICKED, payload };
};
export const updateOptionChainLastTick = (payload) => {
    return { type: OPTION_CHAIN?.OPTION_CHAIN_LAST_STACK, payload };
};

export const clearOptionChain = () => {
    return { type: OPTION_CHAIN?.CLEAR_OPTION_CHAIN_DATA, payload: '' };
};


export const updateObjMultiLegData = (payload) => {
    return { type: OPTION_CHAIN?.UPDATE_OBJ_MULTILEG_DATA, payload: deepClone(payload) };
};

export const updateLegDataForOptionChain = (payload = []) => {
    return { type: OPTION_CHAIN.LEG_DATA_FOR_OPTION_CHAIN, payload };
};


export const openOptionChain = (objPayload) => async (dispatch, getState) => {


    let convertedId = getMktSegIdFromApiExchangeName(getAssetExchangeNameFromMktSegId(getMktSegIdFromMappedMktSegId(objPayload?.mappedId)));
    dispatch(updateOptionChainPayload({ ...objPayload, mappedId: convertedId, id: convertedId, extraId: objPayload?.mappedId }));
    try {
        if (objPayload?.location === location.MULTI_LEG) {
            dispatch(toggleOptionChainCheckBox(true));
        } else {
            dispatch(toggleOptionChainCheckBox(false));
        }
        sendBestFiveRequest({
            exchangeId: Number(convertedId),
            token: Number(objPayload?.assetToken),
            isSubscribe: true,
        });
        let symbol = modifySymbol(objPayload?.symbol);
        let objLoginSession = getState()?.auth?.objLoginSession;
        let arrDistinctDates;
        let params = objPayload?.location === location?.INDICES ? getViewAllowed(objLoginSession) : getViewAllowedOptnChain(objPayload?.mappedId, objLoginSession);
        let instrumentName = objPayload?.location === location?.INDICES ? SCRIP_INSTRUMENTS?.OPTIDX : getInstrumentName(objPayload?.instrumentName);
        if (objPayload?.location === "GLOBAL_SEARCH") {
            arrDistinctDates = objPayload?.distinctDates;
        } else {
            let getDistinctDates = await getDistinctExpirybyTokenApi({ assetToken: objPayload?.assetToken, instrumentName: instrumentName, params: params });
            arrDistinctDates = await getDistinctDates?.data?.result?.aggregations?.optsym?.buckets[0]?.optexp?.buckets.map(item => item.key.toUpperCase());
        }

        if (arrDistinctDates === undefined) {
            store.dispatch(updateOptionChainLoading(false));
        }
        //Ameersha N -BREEZE - BT-109096 - 12-04-2024 -- Scrip Overview Option Chain
        const sortedDateStrings = arrDistinctDates?.sort((a, b) => sortDateInStringsInSequence(a) - sortDateInStringsInSequence(b));
        let expiryDate = objPayload?.location === location?.GLOBAL_SEARCH ? objPayload?.expiryDate : objPayload?.expiryDate?.length > 0 ? objPayload?.expiryDate : sortedDateStrings[0];
        // check if payload expiry date is present in sortedDateStrings
        if (!sortedDateStrings.includes(expiryDate)) {
            expiryDate = sortedDateStrings[0];
        }

        if (!arrDistinctDates?.includes(objPayload?.expiryDate)) {
            dispatch(updateOptionChainPayload({ ...objPayload, mappedId: convertedId, id: convertedId, extraId: objPayload?.mappedId, expiryDate: expiryDate }));
        }
        store.dispatch(updateOptionChainLoading(false));
        dispatch(saveDistinctDatesOptions([...sortedDateStrings]));
        let objOptionChainData = await getScripFromInstrumentAndExchangeApi({ expiryDate: expiryDate, symbol: symbol, nExchangesViewAllowed: objLoginSession?.nExchangesViewAllowed });
        let arrSelectedOptionContractData = objOptionChainData?.data?.result?.hits?.hits;
        // filtering need to be done and then conversion
        let filteredData;
        if (objPayload.instrumentName.includes(SCRIP_INSTRUMENTS.CUR_TEXT) || objPayload.instrumentName.includes(SCRIP_INSTRUMENTS.OPTFUT) || objPayload.instrumentName.includes(SCRIP_INSTRUMENTS.OPTCUR_TEXT) || objPayload.instrumentName.includes(SCRIP_INSTRUMENTS.FUTCUR) || objPayload.instrumentName.includes(SCRIP_INSTRUMENTS.FUTCOM)) {
            filteredData = arrSelectedOptionContractData?.filter(x => x._source.nExpiryDate1 === expiryDate && x?._source?.sOptionType?.length > 0 && x?._source?.MktSegId === objPayload?.id);
        } else {
            filteredData = arrSelectedOptionContractData?.filter(x => x._source.nExpiryDate1 === expiryDate && x?._source?.sOptionType?.length > 0);
        }

        dispatch(updateOptionChainDummyData(filteredData));
    } catch (error) {
        console?.log(error);
    }
};

export const updateDateSelection = (objPayload) => async (dispatch, getState) => {
    let objLoginSession = getState()?.auth?.objLoginSession;
    const objOptionChainPayload = getState()?.optionChain?.objOptionChainPayload;
    sendBestFiveRequest({
        exchangeId: Number(objOptionChainPayload?.mappedId),
        token: Number(objOptionChainPayload?.assetToken),
        isSubscribe: true,
    });
    let objOptionChainData = await getScripFromInstrumentAndExchangeApi({ expiryDate: objPayload?.expiryDate, symbol: objPayload?.symbol, nExchangesViewAllowed: objLoginSession?.nExchangesViewAllowed });
    dispatch(updateOptionChainLoading(false));
    let arrSelectedOptionContractData = objOptionChainData?.data?.result?.hits?.hits;
    // filtering need to be done and then conversion
    if (objOptionChainPayload.instrumentName.includes(SCRIP_INSTRUMENTS.CUR_TEXT)) {
        let id = getMktSegIdFromMappedMktSegId(objOptionChainPayload?.extraId);
        let filteredData1 = arrSelectedOptionContractData?.filter(x => x._source.nExpiryDate1 === objPayload?.expiryDate && x?._source?.sOptionType?.length > 0 && x?._source?.MktSegId === id);
        dispatch(updateOptionChainDummyData(filteredData1));
    } else {
        let filteredData = arrSelectedOptionContractData?.filter(x => x._source.nExpiryDate1 === objPayload?.expiryDate && x?._source?.sOptionType?.length > 0);
        dispatch(updateOptionChainDummyData(filteredData));
    }

    return Promise.resolve(true);
};


export const updateOptionChainPayload = (payload) => {
    return { type: OPTION_CHAIN?.UPDATE_OPTION_CHAIN_PAYLOAD, payload };
};

export const toggleOptionChainCheckBox = (payload = false) => {
    return { type: OPTION_CHAIN?.OPTION_CHAIN_TOGGLE_CHECKBOX, payload };
};

export const updateOptionChainLoading = (payload) => {
    return { type: OPTION_CHAIN?.UPDATE_OPTION_CHAIN_LOADING, payload };
};

function reAdjustOptionChainData(x, arr) {
    //This function will add the missed CE or PE Data according to the missed data index and replace with missed Dummy data --Ameersha N
    if (x >= 0 && x <= arr?.length - 1) {
        if (arr[x]?._source?.sOptionType === "PE" && arr[x + 1]?._source?.sOptionType === "CE") {
            arr.splice(x, 0, { _source: { sOptionType: "CE", extra: 'CE MISSED', nStrikePrice1: arr[x]?._source?.nStrikePrice1 } });
            return arr;
        } else if (arr[x]?._source?.sOptionType === "CE" && arr[x + 1]?._source?.sOptionType === "CE" && arr[x - 1]?._source?.sOptionType === "PE") {
            arr.splice(x + 1, 0, { _id: `${x}-${x}`, _source: { sOptionType: "PE", extra: 'PE MISSED', nStrikePrice1: arr[x - 1]?._source?.nStrikePrice1 } });
            return arr;
        };
        return arr;
    }
    return arr;
    //This function will add the missed CE or PE Data according to the missed data index and replace with missed Dummy data --Ameersha N
}

export const updateOptionChainDummyData = (data1) => {
    /*
        This actiosn will form the data in structure for grid option chain
        Instead lopping whole array this loop skips one index as the CE and PE will be in alternate position so to avoided
        long loop at a time a single array is formed so both and CALL and PUT data will be in the same array
    */
    let arrToBeMadeForOptionChain = [];
    let arrStrikePrices = [];

    let arrNewData = [];

    for (let i = 0; i <= data1?.length - 2; i += 2) {
        arrStrikePrices?.push(data1[i]?._source?.nStrikePrice1);
        arrNewData = reAdjustOptionChainData(i, data1);
    }

    for (let i = 0; i <= arrNewData?.length - 2; i += 2) {
        const arrOptionChainIndex = Object.values(OPTION_CHAIN_GRID_INDEX).sort((a, b) => a - b);
        const arrOptionChainGridRowData = new Array(arrOptionChainIndex[arrOptionChainIndex.length - 1] + 1).fill('0.00');
        //Setting data recieved from api with apt values
        arrOptionChainGridRowData[OPTION_CHAIN_GRID_INDEX.CALL_SEGMENT_ID_TOKEN] = '-';
        arrOptionChainGridRowData[OPTION_CHAIN_GRID_INDEX.PUT_SEGMENT_ID_TOKE] = '-';
        arrOptionChainGridRowData[OPTION_CHAIN_GRID_INDEX.STRIKE_PRICE] = arrNewData[i]?._source?.nStrikePrice1;
        arrOptionChainGridRowData[OPTION_CHAIN_GRID_INDEX.ID_FOR_OPTION_CHAIN_GRID] = arrToBeMadeForOptionChain?.length;
        arrOptionChainGridRowData[OPTION_CHAIN_GRID_INDEX.CALL_SEGMENT_ID_TOKEN] = arrNewData[i]?._source?.extra === "CE MISSED" ? i?.toString() : arrNewData[i]?._source.MktSegId + '_' + arrNewData[i]?._id?.split('-')[1] + '_CALL';
        arrOptionChainGridRowData[OPTION_CHAIN_GRID_INDEX.PUT_SEGMENT_ID_TOKE] = arrNewData[i + 1]?._source?.extra === "PE MISSED" ? i?.toString() : arrNewData[i + 1]?._source.MktSegId + '_' + arrNewData[i + 1]?._id?.split('-')[1] + '_PUT';
        arrOptionChainGridRowData[OPTION_CHAIN_GRID_INDEX.CALL_NEXPIRY_DATE] = arrNewData[i]?._source?.extra !== "CE MISSED" ? arrNewData[i]?._source?.nExpiryDate1 : '-';
        arrOptionChainGridRowData[OPTION_CHAIN_GRID_INDEX.CALL_NSTRIKE_PRICE] = arrNewData[i]?._source?.extra !== "CE MISSED" ? arrNewData[i]?._source?.nStrikePrice1 : '-';
        arrOptionChainGridRowData[OPTION_CHAIN_GRID_INDEX.PUT_NEXPIRY_DATE] = arrNewData[i + 1]?._source?.extra !== "PE MISSED" ? arrNewData[i + 1]?._source?.nExpiryDate1 : '-';
        arrOptionChainGridRowData[OPTION_CHAIN_GRID_INDEX.PUT_NSTRIKE_PRIE] = arrNewData[i + 1]?._source?.extra !== "PE MISSED" ? arrNewData[i + 1]?._source?.nStrikePrice1 : '-';
        arrOptionChainGridRowData[OPTION_CHAIN_GRID_INDEX.CALL_MULTILEG_COLOR] = arrNewData[i]?._source?.extra !== "CE MISSED" ? false : '-';
        arrOptionChainGridRowData[OPTION_CHAIN_GRID_INDEX.PUT_MULTILEG_COLOR] = arrNewData[i + 1]?._source?.extra !== "PE MISSED" ? false : '-';
        arrOptionChainGridRowData[OPTION_CHAIN_GRID_INDEX.IS_CALL_DATA_PRESENT] = arrNewData[i]?._source?.extra !== "CE MISSED" ? "" : '-';;
        arrOptionChainGridRowData[OPTION_CHAIN_GRID_INDEX.IS_PUT_DATA_PRESENT] = arrNewData[i + 1]?._source?.extra !== "PE MISSED" ? "" : '-';

        //Adding '-' for fields that we use from socket data in case CE data is missed
        if (arrNewData[i]?._source?.extra === "CE MISSED") {
            arrOptionChainGridRowData[OPTION_CHAIN_GRID_INDEX.GAMMA_CALL] = '-';
            arrOptionChainGridRowData[OPTION_CHAIN_GRID_INDEX.THETA_CALL] = '-';
            arrOptionChainGridRowData[OPTION_CHAIN_GRID_INDEX.VEGA_CALL] = '-';
            arrOptionChainGridRowData[OPTION_CHAIN_GRID_INDEX.DELTA_CALL] = '-';
            arrOptionChainGridRowData[OPTION_CHAIN_GRID_INDEX.VOLUME_CALL] = '-';
            arrOptionChainGridRowData[OPTION_CHAIN_GRID_INDEX.IV_CALL] = '-';
            arrOptionChainGridRowData[OPTION_CHAIN_GRID_INDEX.OI_CALL] = '-';
            arrOptionChainGridRowData[OPTION_CHAIN_GRID_INDEX.PERCENT_CHANGE_CALL] = '-';
            arrOptionChainGridRowData[OPTION_CHAIN_GRID_INDEX.LTP_CALL] = '-';
            arrOptionChainGridRowData[OPTION_CHAIN_GRID_INDEX.CALL_PERCENT_CHANGE_LTP] = '-';
            arrOptionChainGridRowData[OPTION_CHAIN_GRID_INDEX.CALL_CHANGE_IN_LTP] = '-';
            arrOptionChainGridRowData[OPTION_CHAIN_GRID_INDEX.CALL_ASK_QTY] = '-';
            arrOptionChainGridRowData[OPTION_CHAIN_GRID_INDEX.CALL_BUY_PRICE] = '-';
            arrOptionChainGridRowData[OPTION_CHAIN_GRID_INDEX.CALL_SELL_PRICE] = '-';
        }
        //Adding '-' for fields that we use from socket data in case PE data is missed
        if (arrNewData[i + 1]?._source?.extra === "PE MISSED") {
            arrOptionChainGridRowData[OPTION_CHAIN_GRID_INDEX.GAMMA_PUT] = '-';
            arrOptionChainGridRowData[OPTION_CHAIN_GRID_INDEX.THETA_PUT] = '-';
            arrOptionChainGridRowData[OPTION_CHAIN_GRID_INDEX.VEGA_PUT] = '-';
            arrOptionChainGridRowData[OPTION_CHAIN_GRID_INDEX.DELTA_PUT] = '-';
            arrOptionChainGridRowData[OPTION_CHAIN_GRID_INDEX.VOLUME_PUT] = '-';
            arrOptionChainGridRowData[OPTION_CHAIN_GRID_INDEX.IV_PUT] = '-';
            arrOptionChainGridRowData[OPTION_CHAIN_GRID_INDEX.OI_PUT] = '-';
            arrOptionChainGridRowData[OPTION_CHAIN_GRID_INDEX.PERCENT_CHANGE_PUT] = '-';
            arrOptionChainGridRowData[OPTION_CHAIN_GRID_INDEX.LTP_PUT] = '-';
            arrOptionChainGridRowData[OPTION_CHAIN_GRID_INDEX.PUT_PERCENT_CHANGE_LTP] = '-';
            arrOptionChainGridRowData[OPTION_CHAIN_GRID_INDEX.PUT_CHANGE_IN_LTP] = '-';
            arrOptionChainGridRowData[OPTION_CHAIN_GRID_INDEX.PUT_ASK_QTY] = '-';
            arrOptionChainGridRowData[OPTION_CHAIN_GRID_INDEX.PUT_BUY_PRICE] = '-';
            arrOptionChainGridRowData[OPTION_CHAIN_GRID_INDEX.PUT_SELL_PRICE] = '-';
        }
        arrToBeMadeForOptionChain?.push(arrOptionChainGridRowData);
    }

    store?.dispatch(updateArrOptionCHainStrikePrices(arrStrikePrices));
    return { type: OPTION_CHAIN?.OPTION_CHAIN_DUMMY_DATA, payload: arrToBeMadeForOptionChain };
};

export const updateArrOptionCHainStrikePrices = (payload) => {
    return { type: OPTION_CHAIN.UPDATE_OPTION_CHAIN_ARR_STRIKE_PRICES, payload };
};


export const updateOptionChainScrips = (payload) => {
    return { type: OPTION_CHAIN.UPDATE_VISIBLESCRIPS_FOR_OPTION_CHAIN, payload };
};

export const updateOptionChainPopoverAction = (payload) => {
    return { type: OPTION_CHAIN.OPTION_CHAIN_POPOVER_UPDATE, payload };
};

/* BT-109096 -- Shuaib.P calls API based on screen from which it is navigated from and fills initial states from API response --start   */
export const updateScripAndOptionData = (objPayload) => async (dispatch, getState) => {
    dispatch(updateScripData(objPayload)); /* this is to save objPayload data in redux */
    dispatch(getOptChainData(objPayload));  /* this is to get distinct expiry dates and strike prices */
};
/* BT-109096 -- Shuaib.P calls API based on screen from which it is navigated from and fills initial states from API response --end */
/*Ameersha N -- BREEZE -- BT-109096 -- OPTION CHAIN GLOABL SEARCH --start*/
export const updateArrOnlyOptionChainDataFromGlobalSearchAction = (payload) => {
    return { type: OPTION_CHAIN.GLOBAL_SEARCH_ONLY_OPTION_CHAIN_DATA, payload };
};

export const updateArrFutOptionScrips = (payload) => {
    return { type: OPTION_CHAIN.GLOBAL_SEARCH_FUT_OPTION_SCRIPS, payload };
};
/*Ameersha N -- BREEZE -- BT-109096 -- OPTION CHAIN GLOABL SEARCH --End*/


/* BT-109096 -- Shuaib.P calls API based on screen from which it is navigated from --start   */
export const getOptChainData = (objPayload) => async (dispatch, getState) => {

    let objLoginSession = getState()?.auth?.objLoginSession;

    let objResp = await _fetchOptionDataBasedOnScreens(objPayload, objLoginSession);

    if (objResp.status) {
        // filter dates in sequence
        //Ameersha N -BREEZE - BT-109096 - 12-04-2024 -- Scrip Overview Option Chain
        const sortedDateStrings = objResp?.data?.arrDistinctDates?.sort((a, b) => sortDateInStringsInSequence(a) - sortDateInStringsInSequence(b));
        // dispatch(saveDistinctDatesOptions([...sortedDateStrings]));
        dispatch(saveOptChainData([...objResp?.data?.arrSelectedOptionContractData]));
    }
};
/* BT-109096 -- Shuaib.P calls API based on screen from which it is navigated from --end*/



/* BT-109096 -- Shuaib.P clears redux of option chain --start*/
export const clearOptionChainData = (objPayload) => async (dispatch, getState) => {
    dispatch(saveOptChainData([]));
    dispatch(saveDistinctDatesOptions([]));
    dispatch(toggleCheckboxes(false));
    dispatch(updateObjOptionData({}));
    // dispatch(updateScripData({}));
    dispatch(handleRowSelection([]));
};
/* BT-109096 -- Shuaib.P clears redux of option chain --end*/


/* BT-109096 -- Shuaib.P pre-sets tabs when navigating from option chain --start*/
export const setOrderEntryTabs = (payload) => {
    return { type: OPTION_CHAIN.SELECTED_TAB, payload };
};
/* BT-109096 -- Shuaib.P pre-sets tabs when navigating from option chain --end*/


export const toggleCheckboxes = (payload) => {
    return { type: OPTION_CHAIN.CHECKBOXES, payload };
};


export const updateObjOptionData = (payload) => {
    return { type: OPTION_CHAIN.OPTION_DATA_WRT_EXPIRY, payload };
};


export const handleRowSelection = (payload) => {
    return { type: OPTION_CHAIN.SELECTED_ROWS, payload };
};


export const updateScripData = (payload) => {
    return { type: OPTION_CHAIN.SCRIP_DATA, payload };
};


export const setSelectedDate = (payload) => {
    return { type: OPTION_CHAIN.SELECTED_DATE, payload };
};

/**BT-109096 -- Shuaib.P Saves data which we get back from API --start*/
export const saveOptChainData = (payload) => {
    return { type: OPTION_CHAIN.SAVE_OPTION_DATA, payload };
};
/**BT-109096 -- Shuaib.P Saves data which we get back from API --end*/

/**BT-109096 -- Shuaib.P Stores distinct dates which we get back from API --start*/
export const saveDistinctDates = (payload) => {
    return { type: OPTION_CHAIN.SAVE_DISTINCT_DATES, payload };
};

export const saveDistinctDatesOptions = (payload) => {
    return { type: OPTION_CHAIN.SAVE_DISTINCT_DATES_OPTIONS, payload };
};
/**BT-109096 -- Shuaib.P Stores distinct dates which we get back from API --end */

export const saveMultiLegFromOptionChain = (payload) => {
    return { type: OPTION_CHAIN.MULTI_LEG_DATA, payload };
};